__turbopack_context__.v({
  "arrow": "EPlmyW_arrow",
  "container": "EPlmyW_container",
});
